import { motion, Variants } from "framer-motion";
import styled from "styled-components";
import { easings, fill } from "../../styles/utils";
import Icon from "../Icon";

interface VideoWallCursorProps {
  expanded?: boolean;
  pressed?: boolean;
}

const Wrapper = styled(motion.div)`
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: grayscale(100%) brightness(700%);
  border-radius: 50%;
`;

const Round = styled(motion.div)`
  ${fill()}
  /* background-color: ${({ theme }) => theme.colors.white}; */
  border-radius: 50%;

  background-color: ${({ theme }) => theme.colors.white};
`;

const Play = styled(motion.div)`
  width: 35%;
  height: 35%;
  clip-path: polygon(10% 0%, 100% 50%, 100% 50%, 10% 100%);
  background-color: black;
`;

const wrapperVariants: Variants = {
  small: { scale: 0.15 },
  expanded: { scale: 1 },
};

const roundVariants: Variants = {
  small: { opacity: 1 },
  expanded: { opacity: 0 },
};
const iconVariants: Variants = {
  small: { scale: 0 },
  expanded: { scale: 1 },
};

export const VideoWallCursor: React.FC<VideoWallCursorProps> = ({
  expanded = false,
  pressed = false,
}) => {
  return (
    <Wrapper
      animate={expanded ? "expanded" : "small"}
      variants={wrapperVariants}
      transition={{ type: "spring", damping: 15 }}
      id="video-wall-curos"
    >
      <Round variants={roundVariants} />
      <Play
        variants={iconVariants}
        transition={{ type: "spring", damping: 20 }}
      />
    </Wrapper>
  );
};
